/**
 * A React component that renders a dropdown list using Material-UI components.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.resultList - The list of results to display in the dropdown.
 * @param {string} props.display - The currently selected value to display.
 * @param {string} props.label - The label for the dropdown.
 * @param {function} props.handleChange - The function to call when the selected value changes.
 *
 * @returns {JSX.Element} The rendered dropdown list component.
 */

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

export default function ListSelection({resultList, display, label, handleChange} : any) {
	  
  return (
	<Box sx={{ mt: 2, mb: 2, minWidth: 120 }}>
		<FormControl fullWidth>
			<InputLabel>{label}</InputLabel>
			<Select 
				value={display}
				label={label}
				onChange={handleChange}
			>
				{resultList?.map((result : any) => (
					<MenuItem key={result.key} value={result.name}>
						{result.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	</Box>
  );
}
